import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Phone, MapPin, Lock, Camera, Save, Package, Heart, LogOut, Edit2 } from 'lucide-react';
import Header from './components/Header13';
import Footer from './components/Footer13';

const Profile13 = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('profile');
    const [isEditing, setIsEditing] = useState(false);
    const [profileData, setProfileData] = useState({
        fullName: 'Meera Krishnan', email: 'meera@example.com', phone: '+91 98765 43210',
        avatar: 'https://ui-avatars.com/api/?name=Meera+Krishnan&size=200&background=C2410C&color=fff',
        address: { street: '42 Craft Lane', city: 'Jaipur', state: 'Rajasthan', pincode: '302001' },
        bio: 'Handloom enthusiast and collector of artisan crafts.',
    });
    const [passwordData, setPasswordData] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setProfileData({ ...profileData, [parent]: { ...profileData[parent], [child]: value } });
        } else { setProfileData({ ...profileData, [name]: value }); }
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData({ ...passwordData, [name]: value });
    };

    const inputStyle = {
        width: '100%', padding: '12px 16px', border: '1px solid #E7E0D6', borderRadius: '4px',
        backgroundColor: '#FBF8F4', fontFamily: "'Mulish', sans-serif", fontSize: '14px',
        color: '#1C1917', outline: 'none', transition: 'border-color 0.3s',
    };

    const tabs = [
        { id: 'profile', label: 'Profile', icon: User },
        { id: 'orders', label: 'Orders', icon: Package },
        { id: 'security', label: 'Security', icon: Lock },
    ];

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@400;700&family=Mulish:wght@300;400;600&display=swap');`}</style>
            <div style={{ fontFamily: "'Mulish', sans-serif" }} className="min-h-screen bg-[#FBF8F4]">
                <Header />
                <main style={{ paddingTop: '72px' }}>
                    <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '40px 20px 80px' }}>
                        {/* Profile Header */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '36px' }}>
                            <div style={{ position: 'relative' }}>
                                <img src={profileData.avatar} alt="Profile" style={{ width: '72px', height: '72px', borderRadius: '50%', objectFit: 'cover', border: '3px solid #C2410C' }} />
                                <button style={{ position: 'absolute', bottom: '0', right: '0', width: '28px', height: '28px', borderRadius: '50%', backgroundColor: '#C2410C', border: '2px solid #FBF8F4', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                    <Camera size={12} color="#FFF" />
                                </button>
                            </div>
                            <div>
                                <h1 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '24px', fontWeight: 700, color: '#1C1917' }}>{profileData.fullName}</h1>
                                <p style={{ fontSize: '14px', color: '#78716C' }}>{profileData.bio}</p>
                            </div>
                        </div>

                        {/* Tabs */}
                        <div style={{ display: 'flex', gap: '4px', marginBottom: '32px', borderBottom: '1px solid #E7E0D6' }}>
                            {tabs.map(tab => (
                                <button key={tab.id} onClick={() => setActiveTab(tab.id)}
                                    style={{
                                        display: 'flex', alignItems: 'center', gap: '6px', padding: '12px 20px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 600,
                                        backgroundColor: 'transparent', color: activeTab === tab.id ? '#C2410C' : '#78716C',
                                        borderBottom: activeTab === tab.id ? '2px solid #C2410C' : '2px solid transparent',
                                        transition: 'all 0.3s',
                                    }}>
                                    <tab.icon size={16} /> {tab.label}
                                </button>
                            ))}
                        </div>

                        {/* Profile Tab */}
                        {activeTab === 'profile' && (
                            <div style={{ backgroundColor: '#F7F3ED', borderRadius: '8px', padding: '28px', border: '1px solid #E7E0D6' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                                    <h2 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '20px', fontWeight: 700, color: '#1C1917' }}>Personal Information</h2>
                                    <button onClick={() => setIsEditing(!isEditing)}
                                        style={{ display: 'flex', alignItems: 'center', gap: '6px', background: 'none', border: 'none', cursor: 'pointer', fontSize: '13px', color: '#C2410C', fontWeight: 600 }}>
                                        <Edit2 size={14} /> {isEditing ? 'Cancel' : 'Edit'}
                                    </button>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    {[
                                        { label: 'Full Name', name: 'fullName', value: profileData.fullName, icon: User },
                                        { label: 'Email', name: 'email', value: profileData.email, icon: Mail },
                                        { label: 'Phone', name: 'phone', value: profileData.phone, icon: Phone },
                                        { label: 'City', name: 'address.city', value: profileData.address.city, icon: MapPin },
                                    ].map(field => (
                                        <div key={field.name}>
                                            <label style={{ fontSize: '12px', fontWeight: 600, color: '#78716C', display: 'block', marginBottom: '6px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>{field.label}</label>
                                            <input name={field.name} value={field.value} onChange={handleInputChange} disabled={!isEditing}
                                                style={{ ...inputStyle, opacity: isEditing ? 1 : 0.7, cursor: isEditing ? 'text' : 'default' }}
                                                onFocus={(e) => { if (isEditing) e.target.style.borderColor = '#C2410C'; }}
                                                onBlur={(e) => { e.target.style.borderColor = '#E7E0D6'; }} />
                                        </div>
                                    ))}
                                </div>
                                {isEditing && (
                                    <button style={{ marginTop: '24px', padding: '14px 28px', backgroundColor: '#C2410C', color: '#FFF', border: 'none', borderRadius: '4px', fontSize: '13px', fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
                                        onClick={() => setIsEditing(false)}>
                                        <Save size={16} /> Save Changes
                                    </button>
                                )}
                            </div>
                        )}

                        {/* Orders Tab */}
                        {activeTab === 'orders' && (
                            <div style={{ textAlign: 'center', padding: '40px' }}>
                                <Package size={48} style={{ color: '#E7E0D6', margin: '0 auto 16px' }} />
                                <p style={{ fontSize: '16px', color: '#78716C', marginBottom: '20px' }}>View and manage your orders</p>
                                <button onClick={() => navigate('/template13/orders')}
                                    style={{ padding: '14px 32px', backgroundColor: '#C2410C', color: '#FFF', border: 'none', borderRadius: '4px', fontSize: '13px', fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', cursor: 'pointer' }}>
                                    View Orders
                                </button>
                            </div>
                        )}

                        {/* Security Tab */}
                        {activeTab === 'security' && (
                            <div style={{ backgroundColor: '#F7F3ED', borderRadius: '8px', padding: '28px', border: '1px solid #E7E0D6', maxWidth: '500px' }}>
                                <h2 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '20px', fontWeight: 700, color: '#1C1917', marginBottom: '24px' }}>Change Password</h2>
                                {['currentPassword', 'newPassword', 'confirmPassword'].map((field) => (
                                    <div key={field} style={{ marginBottom: '16px' }}>
                                        <label style={{ fontSize: '12px', fontWeight: 600, color: '#78716C', display: 'block', marginBottom: '6px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                                            {field.replace(/([A-Z])/g, ' $1').trim()}
                                        </label>
                                        <input name={field} type="password" value={passwordData[field]} onChange={handlePasswordChange} style={inputStyle}
                                            onFocus={(e) => { e.target.style.borderColor = '#C2410C'; }} onBlur={(e) => { e.target.style.borderColor = '#E7E0D6'; }} />
                                    </div>
                                ))}
                                <button style={{ marginTop: '8px', padding: '14px 28px', backgroundColor: '#C2410C', color: '#FFF', border: 'none', borderRadius: '4px', fontSize: '13px', fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer' }}>
                                    Update Password
                                </button>
                            </div>
                        )}

                        {/* Logout */}
                        <button onClick={() => navigate('/template13/login')}
                            style={{ marginTop: '32px', display: 'flex', alignItems: 'center', gap: '8px', background: 'none', border: 'none', cursor: 'pointer', fontSize: '14px', color: '#78716C' }}>
                            <LogOut size={18} /> Sign Out
                        </button>
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Profile13;
